// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gerencias-panel-container {
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.gerencias-header {
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.gerencias-header h1 {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 6px 0;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

[data-theme="dark"] .gerencias-header h1 {
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  color: #64748b;
  margin: 0;
  font-size: 16px;
}

.card-glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 20px;
  box-shadow: 0 4px 20px -2px rgba(148, 163, 184, 0.12), 
              0 2px 8px -1px rgba(148, 163, 184, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-theme="dark"] .card-glass {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.3);
}

.gerencias-layout {
  display: grid;
  grid-template-columns: 380px 1fr;
  gap: 32px;
  align-items: start;
}

@media (max-width: 1024px) {
  .gerencias-layout {
    grid-template-columns: 1fr;
  }
}

.form-section {
  padding: 32px;
}

.form-section h2 {
  font-size: 20px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 24px;
  color: #1e293b;
}

[data-theme="dark"] .form-section h2 {
  color: #f1f5f9;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

[data-theme="dark"] .form-group label {
  color: #94a3b8;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  font-size: 14px;
  transition: all 0.2s;
  box-sizing: border-box;
}

[data-theme="dark"] .form-group input,
[data-theme="dark"] .form-group textarea,
[data-theme="dark"] .form-group select {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(15, 23, 42, 0.8);
  color: #f1f5f9;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.btn-primary {
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: white;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
  transition: all 0.2s;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.list-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.filter-bar {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-bar label {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

[data-theme="dark"] .filter-bar label {
  color: #94a3b8;
}

.filter-bar select {
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: transparent;
  color: #1e293b;
  font-size: 14px;
  outline: none;
}

[data-theme="dark"] .filter-bar select {
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
  background: #0f172a;
}

.gerencias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.gerencia-card {
  padding: 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.gerencia-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -10px rgba(148, 163, 184, 0.3);
}

[data-theme="dark"] .gerencia-card:hover {
  box-shadow: 0 12px 30px -10px rgba(0, 0, 0, 0.5);
  border-color: rgba(99, 102, 241, 0.2);
}

.gerencia-card.desactivada {
  opacity: 0.65;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
}

[data-theme="dark"] .card-header h3 {
  color: #f1f5f9;
}

.status-badge {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 6px;
}

.status-badge.activa {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.status-badge.inactiva {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.vp-tag {
  font-size: 12px;
  color: #6366f1;
  font-weight: 600;
  margin-bottom: 12px;
}

.desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 24px 0;
  flex-grow: 1;
}

[data-theme="dark"] .desc {
  color: #94a3b8;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(226, 232, 240, 0.6);
  padding-top: 16px;
}

[data-theme="dark"] .card-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.fecha {
  font-size: 12px;
  color: #94a3b8;
}

.btn-action {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.btn-disable {
  background: rgba(239, 68, 68, 0.08);
  color: #ef4444;
}

.btn-disable:hover {
  background: #ef4444;
  color: white;
}

.btn-enable {
  background: rgba(16, 185, 129, 0.08);
  color: #10b981;
}

.btn-enable:hover {
  background: #10b981;
  color: white;
}

.error-banner, .exito-banner {
  padding: 16px 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 500;
}

.error-banner {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fee2e2;
}

.exito-banner {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #d1fae5;
}

.loading-state, .empty-state {
  padding: 48px;
  text-align: center;
  color: #64748b;
}

@media (max-width: 768px) {
  .gerencias-panel-container {
    padding: 16px;
  }
  
  .gerencias-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .gerencias-header h1 {
    font-size: 24px;
  }
  
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-bar select {
    width: 100%;
  }
  
  .gerencias-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/GerenciasPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB;sDACoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,0CAA0C;EAC1C,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".gerencias-panel-container {\n  padding: 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.gerencias-header {\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.gerencias-header h1 {\n  font-size: 32px;\n  font-weight: 800;\n  margin: 0 0 6px 0;\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n[data-theme=\"dark\"] .gerencias-header h1 {\n  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.subtitle {\n  color: #64748b;\n  margin: 0;\n  font-size: 16px;\n}\n\n.card-glass {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 20px;\n  box-shadow: 0 4px 20px -2px rgba(148, 163, 184, 0.12), \n              0 2px 8px -1px rgba(148, 163, 184, 0.08);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n[data-theme=\"dark\"] .card-glass {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.3);\n}\n\n.gerencias-layout {\n  display: grid;\n  grid-template-columns: 380px 1fr;\n  gap: 32px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .gerencias-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.form-section {\n  padding: 32px;\n}\n\n.form-section h2 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-top: 0;\n  margin-bottom: 24px;\n  color: #1e293b;\n}\n\n[data-theme=\"dark\"] .form-section h2 {\n  color: #f1f5f9;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n[data-theme=\"dark\"] .form-group label {\n  color: #94a3b8;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid #cbd5e1;\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  font-size: 14px;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n[data-theme=\"dark\"] .form-group input,\n[data-theme=\"dark\"] .form-group textarea,\n[data-theme=\"dark\"] .form-group select {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(15, 23, 42, 0.8);\n  color: #f1f5f9;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 14px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);\n  transition: all 0.2s;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.list-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.filter-bar {\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-bar label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n}\n\n[data-theme=\"dark\"] .filter-bar label {\n  color: #94a3b8;\n}\n\n.filter-bar select {\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  background: transparent;\n  color: #1e293b;\n  font-size: 14px;\n  outline: none;\n}\n\n[data-theme=\"dark\"] .filter-bar select {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #f1f5f9;\n  background: #0f172a;\n}\n\n.gerencias-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.gerencia-card {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.gerencia-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 24px -10px rgba(148, 163, 184, 0.3);\n}\n\n[data-theme=\"dark\"] .gerencia-card:hover {\n  box-shadow: 0 12px 30px -10px rgba(0, 0, 0, 0.5);\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\n.gerencia-card.desactivada {\n  opacity: 0.65;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.card-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.3;\n}\n\n[data-theme=\"dark\"] .card-header h3 {\n  color: #f1f5f9;\n}\n\n.status-badge {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.status-badge.activa {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.status-badge.inactiva {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.vp-tag {\n  font-size: 12px;\n  color: #6366f1;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.desc {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0 0 24px 0;\n  flex-grow: 1;\n}\n\n[data-theme=\"dark\"] .desc {\n  color: #94a3b8;\n}\n\n.card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(226, 232, 240, 0.6);\n  padding-top: 16px;\n}\n\n[data-theme=\"dark\"] .card-footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.fecha {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.btn-action {\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.btn-disable {\n  background: rgba(239, 68, 68, 0.08);\n  color: #ef4444;\n}\n\n.btn-disable:hover {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-enable {\n  background: rgba(16, 185, 129, 0.08);\n  color: #10b981;\n}\n\n.btn-enable:hover {\n  background: #10b981;\n  color: white;\n}\n\n.error-banner, .exito-banner {\n  padding: 16px 24px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.error-banner {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fee2e2;\n}\n\n.exito-banner {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #d1fae5;\n}\n\n.loading-state, .empty-state {\n  padding: 48px;\n  text-align: center;\n  color: #64748b;\n}\n\n@media (max-width: 768px) {\n  .gerencias-panel-container {\n    padding: 16px;\n  }\n  \n  .gerencias-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .gerencias-header h1 {\n    font-size: 24px;\n  }\n  \n  .filter-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .filter-bar select {\n    width: 100%;\n  }\n  \n  .gerencias-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
